import { Box, IconButton, Paper, Tab, Tabs, Tooltip } from "@material-ui/core";
import React from "react";
import {
  Code,
  Visibility,
  Fullscreen,
  PhotoLibrary,
} from "@material-ui/icons";
import useSignableDocumentsEditorStyles from "../hooks/useSignableDocumentsEditorStyles";

function SignableDocumentsEditorTabs({
  resources,
  viewMode,
  handleTabChange,
  disabled,
  handleOpenMediaLibrary,
  handleOpenFullScreen,
}) {
  const classes = useSignableDocumentsEditorStyles();

  return (
    <Paper className={classes.tabsContainer}>
      <Box display="flex" alignItems="center">
        <Box flex={1}>
          <Tabs
            value={viewMode}
            onChange={handleTabChange}
            indicatorColor="primary"
            textColor="primary"
            variant="fullWidth"
          >
            <Tab
              icon={<Code />}
              label={resources["HTMLEditor"]}
              disabled={disabled}
              id="html-editor-tab"
            />

            <Tab
              icon={<Visibility />}
              label={resources["Preview"]}
              id="preview-tab"
              disabled={disabled}
            />
          </Tabs>
        </Box>
        <>
          <Tooltip title={resources["MediaLibraryTooltip"]}>
            <span>
              <IconButton
                onClick={handleOpenMediaLibrary}
                disabled={disabled}
                style={{ marginRight: 8 }}
                id="media-library-button"
              >
                <PhotoLibrary />
              </IconButton>
            </span>
          </Tooltip>
          <Tooltip title={resources["OpenFullScreenTooltip"]}>
            <span>
              <IconButton
                onClick={handleOpenFullScreen}
                disabled={disabled}
                style={{ marginRight: 8 }}
                id="full-screen-button"
              >
                <Fullscreen />
              </IconButton>
            </span>
          </Tooltip>
        </>
      </Box>
    </Paper>
  );
}

export default SignableDocumentsEditorTabs;
